import { tickerItems } from "../../../mocks/portalData";

export default function Ticker() {
  return (
    <div className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto flex max-w-[1320px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex items-center gap-1.5 whitespace-nowrap text-xs font-black text-primary-600">
          <i className="ri-flashlight-fill text-sm"></i>
          即时热讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="no-scrollbar flex gap-8 overflow-x-auto">
            {tickerItems.map((item, idx) => (
              <a href="#hot" key={idx} className="group flex shrink-0 items-center gap-2 text-xs text-foreground-700">
                <span className="font-mono text-foreground-400">{item.time}</span>
                <span className="whitespace-nowrap transition-colors group-hover:text-primary-600">{item.text}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}